export enum APP_DEFAULTS {
  IDENEDI_GROUP_ID = 'GAA0000000000',
  OWNERSHIP_CONTRACT_ID = 'A0A0A0',
  OWNERSHIP_SHARE_FIELD_ID = 'OsnershipShare', // The sepllings are wrong from server
  READ_MORE_IDENTIFIER = '6K0vakGy5D9TQ-_MSJK1TJBTR0IKysZL3YdM3_xDxNZH7v8NNnehg4f_r0_9IClvQ9reixQae4ER_3JiS_SHKqC83VxHNwM-wflQcxDGEoL1lrw1CsVXwnVSOPvCoRkKFdCVLK9fH8-f30-hdcU7icCD5FCrfMVo7wpZ4ClRtJKZb9bOPnptG2LCByNyrMrn1bnQUsp3eECVXzc-RJYW9fGNgTfwjBxumPEtBAr4Nf5ZFep9LGRaLi--HSt_lTruUOyT3--bkdlpBuyXBsIg5V67ngM'
}
